import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../common/Button'
import { FiPlusCircle } from 'react-icons/fi'
import { MdToggleOn, MdToggleOff } from 'react-icons/md'
import { TiThumbsDown, TiThumbsOk, TiThumbsUp } from 'react-icons/ti'
import Rating from '@mui/material/Rating'
import Stack from '@mui/material/Stack'
import { IoIosArrowDown } from 'react-icons/io'
import Input from '../../common/Input'
import Typography from '../../common/Typography'
import Select from '../../common/Select'
import { FaPersonRunning, FaTruckFast } from 'react-icons/fa6'
import { GiTortoise } from 'react-icons/gi'

const SurveyForm = ({ onClose, onSubmit }) => {
  const [selectedUserFilter, setSelectedUserFilter] = useState('allUsers')
  const [selectedQuestionFilter, setSelectedQuestionFilter] = useState('moodScale')
  const [selectedSurveyFilter, setSelectedSurveyFilter] = useState('appExperience')
  const [value, setValue] = useState('')
  const handleFilterChange = e => {
    setSelectedUserFilter(e.target.value)
    setSelectedQuestionFilter(e.target.value)
    setSelectedSurveyFilter(e.target.value)
  }

  const handleTextChange = e => {
    setValue(e.target.value)
  }
  return (
    <div className="bg-white px-8 py-4 rounded-lg border border-gray-200">
      <div className="flex justify-end">
        <Button variant="link" className="border border-zinc-900 hover:bg-transparent hover:border-gray-400">
          <FiPlusCircle className="text-xl text-gray-500 mr-2" />
          <span className="text-black text-base">Add</span>
        </Button>
      </div>
      <form className="">
        <div className="flex flex-col">
          <label htmlFor="questionType">Survey type</label>
          <Select
            id="surveyType"
            name="surveyType"
            value={selectedSurveyFilter}
            onChange={handleFilterChange}
            options={[
              { value: 'appExperience', label: 'App Experience' },
              { value: 'buyingExperience', label: 'Buying Experience' },
              { value: 'rentingExperience', label: 'Renting Experience' },
              { value: 'generalExperience', label: 'General Experience' },
            ]}
            icon={<IoIosArrowDown />}
            required
            size="small"
            className="mb-2 border-x-0 border-t-0 rounded-none focus:border-x-0 focus:border-t-0"
          />
        </div>
        <div className="">
          <label htmlFor="question">Question</label>
          <Input
            id="question"
            name="question"
            type="text"
            value={value}
            onChange={handleTextChange}
            placeholder="Ex: How was your buying experience?"
            className="border-zinc-900 mb-2"
          />
        </div>
        <div className="flex gap-4">
          <div className="flex flex-col">
            <label htmlFor="user">User</label>
            <Select
              id="user"
              name="user"
              value={selectedUserFilter}
              onChange={handleFilterChange}
              icon={<IoIosArrowDown />}
              options={[
                { value: 'allUsers', label: 'All Users' },
                { value: 'customer', label: 'Customer' },
                { value: 'agent', label: 'Agent' },
                { value: 'other', label: 'Other' },
              ]}
              required
              className="border-zinc-900"
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="questionType">Question type</label>
            <Select
              id="questionType"
              name="questionType"
              value={selectedQuestionFilter}
              onChange={handleFilterChange}
              icon={<IoIosArrowDown />}
              options={[
                { value: 'moodScale', label: 'Mood scale' },
                { value: 'starScale', label: 'Star scale' },
                { value: 'actionScale', label: 'Action scale' },
              ]}
              required
              className="mb-2 border-zinc-900"
            />
          </div>
        </div>
        {selectedQuestionFilter === 'moodScale' && (
          <div className="flex mb-1 gap-2 items-center">
            <div className="flex gap-1 items-center">
              <Typography>Great</Typography>
              <TiThumbsUp className="text-primary text-3xl" />
            </div>
            <div className="flex gap-1 items-center">
              <Typography>Okay</Typography>
              <TiThumbsOk className="text-primary text-3xl" />
            </div>
            <div className="flex gap-1 items-center">
              <Typography>Bad</Typography>
              <TiThumbsDown className="text-primary text-3xl" />
            </div>
          </div>
        )}
        {selectedQuestionFilter === 'starScale' && (
          <Stack spacing={1} className="py-2">
            <Rating name="half-rating-read" defaultValue={0} precision={0.5} className="" />
          </Stack>
        )}
        {selectedQuestionFilter === 'actionScale' && (
          <div className="flex mb-1 gap-2 items-center">
            <div className="flex gap-1 items-center">
              <Typography>Smooth</Typography>
              <FaTruckFast className="text-primary text-3xl" />
            </div>
            <div className="flex gap-1 items-center">
              <Typography>Quick</Typography>
              <FaPersonRunning className="text-primary text-3xl" />
            </div>
            <div className="flex gap-1 items-center">
              <Typography>Late</Typography>
              <GiTortoise className="text-primary text-3xl" />
            </div>
          </div>
        )}
        <div>
          <label htmlFor="username">Other?</label>
          <Input
            id="username"
            name="username"
            type="text"
            value={value}
            placeholder="Input user name"
            onChange={handleTextChange}
            className="mb-2 border-zinc-900"
          />
        </div>
        <div>
          <label htmlFor="comment">
            Comment <span className="text-gray-400 opacity-50">(Optional)</span>
          </label>
          <Input
            id="comment"
            name="comment"
            type="text"
            value={value}
            placeholder="Give us your perspective"
            onChange={handleTextChange}
            className="border-zinc-900"
          />
        </div>
        <div className="flex gap-1 mb-2 items-center">
          <button>
            <MdToggleOff className="text-gray-500 text-4xl" />
          </button>
          <Typography>Allow User Input a Comment</Typography>
        </div>
        <div className="flex gap-2 py-1 items-center justify-center">
          <Button className="" onClick={onSubmit}>
            Send
          </Button>
          <Button variant="danger" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  )
}

SurveyForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default SurveyForm
